import { LayerSpecification } from 'maplibre-gl';
import { MapSourceId } from '@daisi/models/map';

export const TRAFFIC_JAM_DETECTION_UNVERIFIED_SOURCE_ID: MapSourceId =
  'realtime-traffic-jam-detection-unverified';

const outline_color = '#000000';
export const TRAFFIC_JAM_DETECTION_UNVERIFIED_LAYERS: LayerSpecification[] = [
  {
    id: TRAFFIC_JAM_DETECTION_UNVERIFIED_SOURCE_ID + '_fdLineOutline',
    type: 'line',
    layout: {
      'line-cap': 'round',
      'line-join': 'round',
    },
    paint: {
      'line-color': outline_color,
      'line-width': 6,
      'line-opacity': {
        // @ts-ignore
        base: 1.75,
        stops: [
          [3, 0.5],
          [12, 0.8],
          [22, 0.9],
        ],
      },
    },
    filter: ['all', ['==', '$type', 'LineString'], ['==', 'isVerified', false]],
    source: TRAFFIC_JAM_DETECTION_UNVERIFIED_SOURCE_ID,
  },
  {
    id: TRAFFIC_JAM_DETECTION_UNVERIFIED_SOURCE_ID + '_fdLine',
    type: 'line',
    layout: {
      'line-cap': 'round',
      'line-join': 'round',
    },
    paint: {
      'line-color': ['get', 'color'],
      'line-width': 4,
      'line-opacity': {
        // @ts-ignore
        base: 1.75,
        stops: [
          [3, 0.5],
          [12, 0.8],
          [22, 0.9],
        ],
      },
    },
    filter: ['all', ['==', '$type', 'LineString'], ['==', 'isVerified', false]],
    source: TRAFFIC_JAM_DETECTION_UNVERIFIED_SOURCE_ID,
  },
  {
    id: TRAFFIC_JAM_DETECTION_UNVERIFIED_SOURCE_ID + '_fdHeadIcon',
    type: 'circle',
    paint: {
      'circle-radius': {
        // @ts-ignore
        base: 1.75,
        stops: [
          [3, 5],
          [12, 8],
          [22, 140],
        ],
      },
      'circle-color': ['get', 'color'],
      'circle-stroke-width': 2,
      'circle-stroke-color': outline_color,
    },
    filter: ['all', ['==', '$type', 'Point'], ['==', 'isVerified', false]],
    source: TRAFFIC_JAM_DETECTION_UNVERIFIED_SOURCE_ID,
  },
  {
    id: TRAFFIC_JAM_DETECTION_UNVERIFIED_SOURCE_ID + 'traffic-jam-direction-layer',
    type: 'symbol',
    source: TRAFFIC_JAM_DETECTION_UNVERIFIED_SOURCE_ID,
    layout: {
      'symbol-placement': 'line',
      'symbol-spacing': 25,
      'icon-allow-overlap': true,
      'icon-rotate': 180,
      'icon-image': 'direction-arrow',
      'icon-size': 0.85,
      visibility: 'visible',
    },
    filter: ['all', ['==', '$type', 'LineString'], ['==', 'isVerified', false]],
    paint: {
      'icon-color': 'black',
    },
  },
];
